export default __webpack_public_path__ + "static/media/check-green.fd799c10.svg";